import i18next from 'i18next'
import React from 'react'

type PublicationMetaProps = {
  date: Date
}

export const PublicationMeta = ({ date }: PublicationMetaProps) => (
  <div className="block block--meta">
    <div className='ls-container ls-gutter ls-spacing'>
      <div className='meta'>
        <time dateTime={date.toISOString()} className="meta__date">
          {date.toLocaleString(
            i18next.language,
            { day: 'numeric', month: 'long', year: 'numeric' })
          }
        </time>
      </div>
    </div>
  </div>
)
